import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const SpecialOffersSection = styled.section`
    padding: ${getPurpurSpacing('600')} 0;
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};
`;

export const SpecialOffersSectionTitle = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('100')};
`;
